import { IBACKENDPAYLOAD } from "./backend";
import { ACTION } from "./command/action";
import { baseParamsType } from "./command/baseparams";
import { ICOMMAND, IKeyMaybeValue, IRESPONSE, RESULT } from "./command/icommand";
import { EnumBooleanStringified } from "../@types";
import { ExitCode } from "./exit-code";
import { clientID } from "./clivechat";
import { EndChatType } from "./live/livechat";

export class CMDP_LOGOUT implements ICOMMAND, IBACKENDPAYLOAD {
  public action: ACTION = ACTION.CMDP_LOGOUT;
  public params: baseParamsType & {
    code?: number;
    allDevices?: EnumBooleanStringified;
  };
  public payload?: unknown;
}

export class CMDP_LOGOUT_RESPONSE extends CMDP_LOGOUT implements IRESPONSE {
  public result: RESULT;
  public commands: ICOMMAND[];
  public values: IKeyMaybeValue;
}

// alias to CMDP_LOGOUT
export class CMDP_SLOGOUT extends CMDP_LOGOUT {
  public action: ACTION = ACTION.CMDP_SLOGOUT;
}

export class CMDP_SLOGOUT_RESPONSE extends CMDP_LOGOUT_RESPONSE {
  public action: ACTION = ACTION.CMDP_SLOGOUT;
}

export class CMDP_CLOGOUT implements ICOMMAND {
  public action = ACTION.CMDP_CLOGOUT;
  public params: baseParamsType &
    clientID & {
      exitCode?: ExitCode;
      exitMessage?: string;
    };
}

export class CMDP_CLOGOUT_RESPONSE extends CMDP_CLOGOUT implements IRESPONSE {
  public result: RESULT;
  public commands: ICOMMAND[];
  public values: {
    endChatType: EndChatType;
    videoTime?: string;
  };
}

export class CMDP_TESTID implements ICOMMAND {
  public action: ACTION = ACTION.CMDP_TESTID;
  public params: baseParamsType & { clientID?: string };
}

export class CMDP_TESTID_RESPONSE extends CMDP_TESTID implements IRESPONSE {
  public result: RESULT;
  public commands: ICOMMAND[];
  public values: IKeyMaybeValue;
}
